import React, { useEffect, useState } from 'react'
import Style from './index.module.css'
import styles from '../Document.module.css'

import { Icon } from 'react-icons-kit'
import { androidShareAlt } from 'react-icons-kit/ionicons/androidShareAlt'
import { basic_trashcan as Trash } from 'react-icons-kit/linea/basic_trashcan'

import { Link, useLocation, useNavigate } from "react-router-dom";
import Modal from '../../../Utils/Modal'
import API from '../../../ApiConfig'
import { GET_VERIFIER_FORMS, DELETE_VERIFIER_FORM, ACTIVATE_VERIFIER_FORM, DEACTIVATE_VERIFIER_FORM } from '../../../Utils/constant'
import { Delay, isInternalUser, ObjectNotEmpty } from '../../../Utils/helper'
import cogoToast from 'cogo-toast-react-17-fix'
import SlideUpWrapper from '../../../components/Transitions/SlideUpWrapper'
import { GenerateQR } from './generateQR'
import dayjs from 'dayjs'

export default function VerifierForms({ id }) {
    const [data, setData] = useState({ "0": [{ "linked_documents": [], }], "1": [{ "linked_documents": [], }] })
    const [activeIndex, setActiveIndex] = useState(null)
    const [FormModal, setFormModal] = useState(false)
    const [loading, setLoading] = useState(false)
    const location = useLocation();
    const path = location.pathname
    const [openMenu, setOpenMenu] = useState(null);
    const [QRModal, setQrLink] = useState(false)

    const isinternalUser = isInternalUser()

    const updatePopup = (bool) => {
        setFormModal(bool);
    };
    const navigate = useNavigate();
    useEffect(() => {
        getVerifierForms()
    }, [])
    function handleActive(index) {
        if (activeIndex === index) setActiveIndex(null)
        else setActiveIndex(index)
    }
    async function getVerifierForms() {
        setLoading(true)
        await Delay()
        API.get(GET_VERIFIER_FORMS + id)
            .then(res => {
                if (res.data.status === 200 && ObjectNotEmpty(res.data.data)) {
                    setData(res.data.data)
                }
                else setData({})
            })
            .catch(err => {
                setLoading(false)
                setData({})
            })
            .finally(() => setLoading(false))
    }
    function deleteForm(form_id) {
        setLoading(true)
        API.delete(DELETE_VERIFIER_FORM + form_id)
            .then(res => {
                setLoading(false)
                cogoToast.success(res.data.data)
                getVerifierForms()

            })
            .catch(err => cogoToast.error('Something went wrong!'))
    }

    function deactivateForm(form_id, toggleState) {
        const URL = toggleState ? DEACTIVATE_VERIFIER_FORM : ACTIVATE_VERIFIER_FORM
        API.get(URL + form_id)
            .then(res => {
                cogoToast.success(res.data.data)
                getVerifierForms()
            })
            .catch(err => cogoToast.error('Something went wrong!'))
    }
    const handleAction = (id) => {
        setOpenMenu(openMenu === id ? null : id)

    }

    const ModalForm = () => {
        const [formName, setFormName] = useState('')
        const [selectedValue, setSelectedValue] = useState('');
        function handleForm(value, e) {
            e.preventDefault();
            if (value.trim().length === 0) {
                cogoToast.error('Enter Form Name')
            }
            // setFormModal(false)
            // setLoading(true)
            // await Delay()
            else if (!selectedValue) {
                cogoToast.error("Please select some value")
            }
            else if (selectedValue === "1") {
                navigate(`../verification-fields/`, { state: { formName: value, state: "Verification fields" } });
            }

            else if (selectedValue === "2") {
                navigate(`../verification-fields/`, { state: { formName: value, state: "Verfication documents" } });
            }
        }
        return (
            <>
                <div className={Style.modalBody}>
                    <div className={Style.modalInput}>
                        <label>Form Name</label>
                        <input placeholder='My Form' value={formName} onChange={e => setFormName(e.target.value)} />
                    </div>
                    <div>
                        <div className={Style.radioBtnWrapper}>
                            Select how you want to add check
                            <label>
                                <div className={Style.radioBtn}>
                                    <span className={Style.label}>
                                        <input type='radio' name='uploadtype' checked={selectedValue === "1"} value={1} onChange={(e) => setSelectedValue(e.target.value)} />
                                        Select by Data fields
                                    </span>
                                    <p className={Style.desc}>Ideal for quick start</p>
                                </div>
                            </label>
                            <label>
                                <div className={Style.radioBtn}>
                                    <span className={Style.label}>
                                        <input type='radio' name='uploadtype' checked={selectedValue === "2"} value={2} onChange={(e) => setSelectedValue(e.target.value)} />
                                        Select by Documents
                                    </span>
                                    <p className={Style.desc}>Add entire document with checks</p>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
                <hr />
                <div className={Style.btnWrapper}>
                    <button className={`btn btn-secondary ${Style.btnSecondary}`} onClick={e => setFormModal(false)} >Cancel</button>
                    <button className='btn btn-primary' type='submit' onClick={e => handleForm(formName, e)}>Continue</button>
                </div>
            </>
        )
    }
    return (
        <div className={Style.container}>
            <div className={Style.header}>
                <h2 className={Style.headerTitle}>Forms</h2>
                {
                    isinternalUser ? 
                    <button className='btn btn-primary' style={{ width: "10%" }} onClick={() => navigate("../forms/formType", { state: { forms: data } })}>+ Add Form</button> : 
                    <button className='btn btn-primary' style={{ width: "12%" }} onClick={() => navigate("/dashboard/forms/selectForms", { state: { forms: data } })}>Choose Form</button>

                }
            </div>
            <SlideUpWrapper>
                {loading ? (
                    <div className={Style.wrapper} style={{ paddingBottom: "10rem" }}>
                        <table>
                            <thead>
                                <tr>
                                    <th className={Style.th}>Form Name</th>
                                    <th className={Style.th}>Fields Name</th>
                                    <th className={Style.th}>Created At</th>
                                    <th className={Style.th}>Last Updated On</th>
                                    <th className={`${Style.th} ${Style.center}`}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {[...Array(2)].map((_, index) => (
                                    <tr>
                                        <td className={`${Style.tdform} cursor-pointer`}>
                                            <div className="shimmer" style={{ width: '7rem' }}></div>
                                        </td>
                                        <td className={Style.tdform}>
                                            <div className="shimmer" style={{ width: '10rem' }}></div>
                                        </td>
                                        <td className={Style.tdform}>
                                            <div className="shimmer" style={{ width: '7rem' }}></div>
                                        </td>
                                        <td className={Style.tdform}>
                                            <div className="shimmer" style={{ width: '7rem' }}></div>
                                        </td>
                                        <td className={`${Style.tdform}`}>
                                            <div style={{ display: "flex", flexDirection: "row", gap: '1rem', justifyContent: "center" }}>
                                                <div className="shimmer" style={{ width: '4rem', height: '2rem' }}></div>
                                                <div className="shimmer" style={{ width: '4rem', height: '2rem' }}></div>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : ObjectNotEmpty(data) ? (
                    <div className={Style.wrapper} style={{ paddingBottom: "10rem" }}>
                        <table style={{ overflow: "visible" }}>
                            <thead>
                                <tr>
                                    <th className={Style.th}>Form Name</th>
                                    <th className={Style.th}>Fields Name</th>
                                    <th className={Style.th}>Created At</th>
                                    <th className={Style.th}>Last Updated On</th>
                                    <th className={`${Style.th} ${Style.center}`}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.keys(data).map((key, index) => {
                                    // console.log(data[key]);

                                    return (
                                        <tr key={index}>
                                            <td className={`${Style.tdform} cursor-pointer`}>
                                                <div>{data[key].form_name}</div>
                                            </td>
                                            <td className={Style.tdform} style={{ width: '20rem' }}>
                                                {data[key]?.required_doc_fields && data[key]?.required_doc_fields.length > 0 ? data[key].required_doc_fields.map((item, i) => (
                                                    <div key={i} className={Style.tdTitle}>
                                                        {item.doc_field_name}
                                                        {i < data[key].required_doc_fields.length - 1 ? <span>, </span> : null}
                                                        <div className={Style.tdList}>
                                                            {item.linked_documents.map((doc, j) => (
                                                                <div key={j}>{doc}</div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ))
                                                    : data[key]?.required_documents && data[key]?.required_documents.length > 0 ? data[key].required_documents.map((item, i) => (
                                                        <div key={i} className={Style.tdTitle}>
                                                            {item.master_document_name}
                                                            {i < data[key].required_documents.length - 1 ? <span>, </span> : null}
                                                        </div>
                                                    )) : null
                                                }
                                            </td>
                                            <td className={Style.tdform}>
                                                {dayjs(data[key].created_at).format('DD MMM YYYY')}
                                            </td>
                                            <td className={Style.tdform}>
                                                {dayjs(data[key].updated_at).format('DD MMM YYYY')}
                                            </td>
                                            <td className={`${Style.tdform}`} style={{ position: "relative" }}>
                                                <div className={Style.center}>
                                                    {
                                                        <button className={`btn ${styles.editPencil}`} style={{ margin: "0px 10px" }} onClick={() => navigate(`../verification-fields/${key}`, { state: data[key] })}>
                                                            <img src='/eyeoutline.svg' className={styles.editicon} />
                                                        </button>
                                                    }
                                                    {
                                                        data[key]?.is_active ? <button className={`btn ${styles.editPencil}`} style={{ margin: "0px 10px" }} onClick={() => navigate(`../verification-fields/${key}`, { state: data[key] })}>
                                                            <img src='/EditPencil.svg' className={styles.editicon} />
                                                        </button> :
                                                            <button className={`btn ${styles.disabled}`} style={{ cursor: 'not-allowed' }} onClick={() => cogoToast.warn("Please activate form")}>
                                                                <img src='/EditPencil.svg' className={styles.editicon} />
                                                            </button>
                                                    }

                                                    {data[key]?.is_deletable && (
                                                        <span className={`btn ${Style.remove}`} onClick={() => deleteForm(data[key][0].form_uuid)}>
                                                            <Icon icon={Trash} />
                                                        </span>
                                                    )}
                                                    {/* <button className={`btn ${data[key]?.is_active ? styles.deactivate : styles.activate}`} onClick={() => deactivateForm(data[key].form_uuid, data[key]?.is_active)} style={{ margin: "0px 5px" }}>
                                                        {data[key]?.is_active ?
                                                            <Icon icon={androidRemoveCircle} color='#525866' /> :
                                                            <Icon icon={androidRemoveCircle} />
                                                        }
                                                    </button> */}
                                                    {
                                                        data[key]?.is_active && !path.includes('/company') ?
                                                            <Link to='../forms/selectType' state={{ form: data[key] }} className={`btn ${styles.activate}`} style={{ textDecoration: 'none' }}>Send Request</Link> :
                                                            <div className={`btn ${styles.activate}`} style={{ textDecoration: 'none', backgroundColor: "lightgray", cursor: "not-allowed" }}>Send Request</div>
                                                    }
                                                    {
                                                        <div style={{ position: "relative" }}>
                                                            {
                                                                <span className={openMenu === index ? styles.moreSelected : styles.more} onClick={() => handleAction(index)}>
                                                                    <img src='/morevert.svg' alt='morevert.svg' />
                                                                </span>}
                                                            {openMenu === index && (
                                                                <div className={styles.ActionMenu}>
                                                                    <button
                                                                        onClick={() => { navigate(`../verification-fields/${key}`, { state: data[key] }); setOpenMenu(null) }}
                                                                        className={styles.menuItems}>
                                                                        <span className={styles.menu}>
                                                                            <img src='/eyeoutline.svg' className={styles.editicon} />
                                                                            View Details
                                                                        </span>
                                                                    </button>
                                                                    <hr style={{ margin: "0px" }} />
                                                                    {data[key]?.is_active ? <button
                                                                        onClick={() => { navigate(`../verification-fields/${key}`, { state: data[key] }); setOpenMenu(null) }}
                                                                        className={styles.menuItems}
                                                                    >
                                                                        <span className={styles.menu}>
                                                                            <img src='/EditPencil.svg' className={styles.editicon} />
                                                                            Edit
                                                                        </span>
                                                                    </button> :
                                                                        <button
                                                                            onClick={() => cogoToast.warn("Please activate form")}
                                                                            className={styles.menuItems}
                                                                            style={{ cursor: "not-allowed", color: "gray" }}
                                                                        >
                                                                            <span className={styles.menu}>
                                                                                <img src='/EditPencil.svg' className={styles.editicon} />
                                                                                Edit
                                                                            </span>
                                                                        </button>
                                                                    }
                                                                    <hr style={{ margin: "0px" }} />
                                                                    {data[key]?.is_active ?
                                                                        <button
                                                                            onClick={() => { navigate("../forms/selectForms", { state: { form: data[key] } }); setOpenMenu(null) }}
                                                                            className={styles.menuItems}
                                                                        >
                                                                            <span className={styles.menu}>
                                                                                <img src='/send.svg' className={styles.editicon} />
                                                                                Send Request
                                                                            </span>
                                                                        </button> : null}
                                                                    <hr style={{ margin: "0px" }} />

                                                                    {data[key]?.is_active ?
                                                                        <button
                                                                            onClick={() => { setQrLink(data[key]); setOpenMenu(null) }}
                                                                            className={styles.menuItems}
                                                                        >
                                                                            <span className={styles.menu}>
                                                                                <Icon icon={androidShareAlt} className={styles.editicon} />
                                                                                Generate QR
                                                                            </span>
                                                                        </button> : null}
                                                                    <hr style={{ margin: "0px" }} />
                                                                    <button
                                                                        onClick={() => { deactivateForm(data[key].form_uuid, data[key]?.is_active); setOpenMenu(null) }}
                                                                        className={styles.menuItems}
                                                                    >
                                                                        <span className={styles.menu}>
                                                                            <img src='/deactivate.svg' className={styles.editicon} />
                                                                            {data[key]?.is_active ? "Deactivate" : "Activate"}
                                                                        </span>
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className={Style.noforms}>
                        <b>No Forms added yet!</b>
                    </div>
                )}
            </SlideUpWrapper>
            <Modal title="Select how you want to create form" isOpen={FormModal} onClose={updatePopup} blockOutsideClick={true} children={<ModalForm />}>
            </Modal>
            <Modal title={QRModal.form_name + " QR"} isOpen={QRModal} onClose={() => setQrLink(false)} blockOutsideClick={true}>
                <GenerateQR form_uuid={QRModal.form_uuid} verifier_id={id} />
            </Modal>
        </div>
    )
}
